import React, { useEffect, useState } from 'react';
import { ClassicEditor } from 'ckeditor5';
import { CKEditor } from '@ckeditor/ckeditor5-react';

import 'ckeditor5/ckeditor5.css';
import './CkEditor.scss';

import PropTypes from 'prop-types';
import { editorConfig } from './CkEditorConfig';
import TooltipComponent from '../../tooltip/TooltipComponent';

const CKEditorComponent = ({
    onCKEditorChange,
    data,
    isDisable,
    placeholder,
    inputInfoConfig,
    ...editorProps
}) => {

    const [editorData, setEditorData] = useState(data || '');

    // Update the state when the data prop changes (external data change)
    useEffect(() => {
        setEditorData(data);
    }, [data]);

    return (
        <div className="ckeditor-sec">
            <CKEditor
                editor={ClassicEditor}
                data={editorData}
                onChange={(event, editor) => {
                    const data = editor.getData();
                    // Only call onCKEditorChange if the data has actually changed
                    if (data !== editorData) {
                        setEditorData(data); // Update internal state
                        onCKEditorChange(data, editor);
                    }
                }}
                config={{
                    ...editorConfig,
                    placeholder:placeholder
                }}
                disabled={isDisable}
                {...editorProps}
            />
              {inputInfoConfig?.isInfoIcon && (
                <TooltipComponent
                    iconName={inputInfoConfig?.iconName}
                    message={inputInfoConfig?.message}
                />
            )}
        </div>
    );
};

CKEditorComponent.propTypes = {
    data: PropTypes.string,
    isdisable: PropTypes.bool,
    onCKEditorChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    editorProps: PropTypes.shape({
        config: PropTypes.shape({
            toolbar: PropTypes.arrayOf(PropTypes.string),
        }),
    }),
    inputInfoConfig: PropTypes.shape({
        isInfoIcon: PropTypes.bool,
        iconName: PropTypes.string,
        message: PropTypes.string,
    }),
};

CKEditorComponent.defaultProps = {
    data: '',
    isdisable: false,
    editorProps: {}
};

export default CKEditorComponent;